import {Component, inject, AfterViewInit, OnInit} from '@angular/core';
import {SpringRestService} from '@aiknow-srl/aik-ngx-http';
import {BaseComponent} from "./BaseComponent";
import {loadMessages, locale as dxLocale, locale} from "devextreme/localization";
import itMessages from "devextreme/localization/messages/it.json";
import enMessages from "devextreme/localization/messages/en.json";
import themes from "devextreme/ui/themes";
import {GrpcAuthorizationOPEService} from "../services/ope/grpc/authorizationOPE.service";
import {UserOpeService} from "../services/ope/userOpe.service";
import {PostLoginCB} from "../ope/user/PostLoginCB";
import DataGrid from "devextreme/ui/data_grid";
import TreeList from "devextreme/ui/tree_list";

DataGrid.defaultOptions({ options: { rowAlternationEnabled: true } });
TreeList.defaultOptions({ options: { rowAlternationEnabled: true } });


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent extends BaseComponent implements OnInit, AfterViewInit {

  private be = inject(SpringRestService);
  private authorizationService = inject(GrpcAuthorizationOPEService);
  private userService = inject(UserOpeService);
  protected viewReady: boolean = false;

  private DEFAULT_LANGUAGE = 'it';

  constructor() {
    super();

    this.appService.isDarkTheme = (sessionStorage.getItem("isDarkTheme") ?? localStorage.getItem("isDarkTheme")) === "true";
    if (!this.appService.isDarkTheme) {
      themes.current('fluent.saas.light');
    } else {
      themes.current('fluent.saas.dark');
    }

    this.appService.printStartingAppInfosInConsole();
    // SET DEFAULT LANGUAGE TO BROWSER LANGUAGE OR 'en'
    const browserLang = this.translate.getBrowserLang();
    if (!!browserLang && this.translate.getLangs().includes(browserLang)) {
      this.translate.setDefaultLang(browserLang);
    } else {
      this.translate.setDefaultLang(this.DEFAULT_LANGUAGE);
    }
    // SET LANGUAGE IF STORED IN LOCAL STORAGE
    const storedLanguage = sessionStorage.getItem('language') ?? localStorage.getItem('language');
    if (storedLanguage !== null) {
      this.translate.use(storedLanguage);
      this.be.setLanguage(storedLanguage);
      locale(navigator.language);
      if (storedLanguage === "it") {
        loadMessages(itMessages);
        dxLocale("it-IT");
      } else if (storedLanguage === "en") {
        loadMessages(enMessages);
        dxLocale("en-GB");
      }
      // locale(localStorage.language);
    } else {
      this.translate.use(this.DEFAULT_LANGUAGE);
      this.be.setLanguage(this.DEFAULT_LANGUAGE);
      // locale(this.DEFAULT_LANGUAGE);
    }
  }

  protected get isImpersonating(): boolean {
    return !!sessionStorage.getItem('impersonationToken');
  }

  ngOnInit(): void {
    this.authorizationService.impersonationEnded$.subscribe(() => {
      const cb = new PostLoginCB();
      cb.i.channel = this.appService.APP_CHANNEL;
      this.userService.postLogin(cb).then(() => {
        this.appService.storeParamsIntoGlobalModel(cb);
      });
    });
  }

  ngAfterViewInit(): void {
    if (this.isImpersonating) {
      document.documentElement.style.setProperty('--impersonation-banner-height', '48px');
    }
    setTimeout(() => {
      this.viewReady = true;
    }, 1000);
  }

}
